<template>
  <Dialog :modal="modal" :modal-class="` z-[999]`">
    <template v-if="popup?.skip_button_name" #close>
      <div :class="['justify-end', 'justify-between']" class="px-10 py-5 flex">
        <ButtonsIcon
          class="ms-auto"
          is-dark
          icon-name="IconTimesWhite"
          @click="handleClose"
        ></ButtonsIcon>
      </div>
    </template>
    <template #container>
      <div class="z-50 w-full h-auto flex justify-center items-center">
        <div
          class="relative px-10 pt-5 pb-10 modal__container z-50 w-full h-auto max-w-lg rounded-2xl bg-brand-greyblack-300 backdrop-blur-xl shadow-xl"
          @click.stop=""
        >
          <div
            class="relative px-10 pt-3 pb-7 modal__container z-50 w-full h-fit max-w-[640px] rounded-2xl bg-brand-greyblack-300 backdrop-blur-xl shadow-xl"
          >
            <div class="h-full flex flex-col justify-between gap-y-2">
              <div class="flex flex-col justify-center">
                <div class="flex flex-col items-center gap-y-2">
                  <!-- <h1
                    class="text-display-small md:text-display-medium text-white opacity-[0.87] text-center ltr:tracking-[2.67px] rtl:tracking-normal"
                  >
                    {{ popup?.title }}
                  </h1> -->
                  <h2
                    class="text-title-big md:text-headline-medium text-center text-white opacity-[0.87] ltr:tracking-[0.72px] rtl:tracking-normal"
                  >
                    {{ popup?.title }}
                  </h2>
                  <p
                    class="text-body-big py-4 text-white opacity-[0.87] tracking-[0.48px] whitespace-pre-line"
                  >
                    {{ popup?.message }}
                  </p>
                </div>
              </div>

              <div class="flex flex-wrap md:flex-nowrap gap-x-6 gap-y-3">
                <ButtonsCta
                  v-if="popup?.skip_button_name"
                  class="variant-secondary outlined w-full !h-9 md:inline-block"
                  @click="handleClose"
                >
                  {{ popup?.skip_button_name }}
                </ButtonsCta>
                <ButtonsCta
                  v-if="popup?.link_button_name"
                  class="variant-primary w-full !h-9 md:inline-block"
                  @click="navigateTo(popup?.skip_link, { external: true })"
                >
                  {{ popup?.link_button_name }}
                </ButtonsCta>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script setup>
const props = defineProps({
  popupData: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["dismiss"]);

const modal = ref(true);
const popup = computed(() => props.popupData);

const handleClose = () => {
  modal.value = false;
  emit("dismiss");
};
</script>

<style></style>
